
const EnquiryTrustSection = ({ data }) => {
    if (!data) return null;
    const { title, rating, items } = data;

    return (
        <section className="py-16 px-6 bg-[#FEF8F2]">
            <div className="max-w-6xl mx-auto">
                <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold text-[#8A1C23] mb-4">{title}</h2>
                    <div className="inline-block text-yellow-800 font-medium mt-2 bg-yellow-50 px-4 py-2 rounded-full">
                        {rating}
                    </div>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-3 gap-6 text-center">
                    {items?.map((element, index) => (
                        <div key={index} className="flex flex-col items-center">
                            <div className="text-3xl text-[#8A1C23] mb-3">{element.icon}</div>
                            <div className="text-base font-semibold text-[#8A1C23] mb-1">{element.title}</div>
                            <div className="text-sm text-gray-500">{element.subtitle}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default EnquiryTrustSection;